import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import Paper from '@mui/material/Paper';
import RadioGroup from '@mui/material/RadioGroup';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import FormWrapper from '../../shared/FormWrapper';

const SelectUserRoleForm = ({ initialSelectedRole = '' }) => {
	const formRef = useRef(null);
	const navigate = useNavigate();

	const [selectedUserRole, setSelectedUserRole] = useState(initialSelectedRole);
	const [hasError, setHasError] = useState(false);
	const handleSelectedUserRoleChange = event => {
		setHasError(false);
		setSelectedUserRole(event.target.value);
	};

	const handleSubmit = e => {
		e.preventDefault();
		if (selectedUserRole) {
			navigate(`${selectedUserRole}`);
		} else {
			setHasError(true);

			formRef.current.scrollIntoView({ behavior: 'smooth' });
		}
	};

	return (
		<FormWrapper id="selectUserRoleForm" onSubmit={handleSubmit}>
			<Grid item xs={12} sm={6} ref={formRef}>
				<Stack spacing={4}>
					<Typography variant="h5" component="h1" color="primary">
						Select Your Role
					</Typography>
					<Stack spacing={1.5}>
						<Typography gutterBottom>
							If you have an existing ASHLink account, please select Existing
							ASHLink User.
						</Typography>
						<Typography gutterBottom>
							For all new users, please select the type of user you are:
						</Typography>
					</Stack>
					{hasError && (
						<Alert severity="error">Please select a role to continue.</Alert>
					)}
					<RadioGroup
						defaultValue={selectedUserRole}
						value={selectedUserRole}
						name="selectedUserRole"
						onChange={handleSelectedUserRoleChange}
					>
						<Stack spacing={2}>
							<Paper variant="EveOutlinedPadded">
								<Typography component="h2" variant="body1" gutterBottom>
									Existing ASHLink user
								</Typography>
								<FormControlLabel
									value="Existing ASHLink User"
									control={<Radio />}
									label={
										<>
											<Typography>
												<strong>Existing ASHLink User</strong>
											</Typography>
											<Typography
												variant="subtitle2"
												component="p"
												color="text.secondary"
											>
												Select this if you have an existing ASHLink account with
												a User ID, Password, and PIN.{' '}
												<strong>Please note for fitness center users: </strong>{' '}
												Creating this primary account for facility should be
												limited to ownership and/or management
											</Typography>
										</>
									}
								/>
							</Paper>
							<Paper variant="EveOutlinedPadded">
								<Typography component="h2" variant="body1" gutterBottom>
									New ASHLink user
								</Typography>
								<Stack spacing={2}>
									<FormControlLabel
										value="Clinical User"
										control={<Radio />}
										label={
											<>
												<Typography>
													<strong>
														Provider/Practitioner/Administrative User
													</strong>
												</Typography>
												<Typography
													variant="subtitle2"
													component="p"
													color="text.secondary"
												>
													This includes all clinical specialities such as
													Acupuncture, Chiropractic, Nutrition Services,
													Therapeutic Massage, Naturopathy, Podiatry, Physical
													Medicine, Rehabilitative Services
												</Typography>
											</>
										}
									/>
									<FormControlLabel
										value="Fitness User"
										control={<Radio />}
										label={
											<>
												<Typography>
													<strong>
														Fitness Location/ActiveOptions Instructor User
													</strong>
												</Typography>
												<Typography
													component="p"
													variant="subtitle2"
													color="text.secondary"
												>
													This includes all network locations such as Fitness
													Centers, Studios, YMCA's, ActiveOptions Instructors
												</Typography>
											</>
										}
									/>
								</Stack>
							</Paper>
						</Stack>
					</RadioGroup>
					<Button type="submit" variant="contained">
						Next
					</Button>
				</Stack>
			</Grid>
		</FormWrapper>
	);
};
SelectUserRoleForm.propTypes = {
	initialSelectedRole: PropTypes.string,
};
export default SelectUserRoleForm;
